import { Card, Form, Col, Modal, Row } from "react-bootstrap";
import { SortApiService } from "../service/SortApiService";
import { useEffect, useState } from "react";
import showToast from "utils/notification";
import '../container-sort.css';

interface Props {
    show: boolean;
    payload?: any;
    toggle: () => void;
    updateTable: () => void;
    isMinimalistTable?: boolean;
}

const RemoveSortCodeConfig = (props: Props) => {

    const [loading, setLoading] = useState<boolean>(false);

    const onClosePopup = () => {
        props.toggle();
    };
    const sortCodeConfigService = SortApiService();

    const onRemoveSortCodeConfig = () => {
        setLoading(true);
        sortCodeConfigService.deleteSortConfig(props.payload.id)
            .then(() => {
                showToast('success', 'Sort group deleted successfully');
                setLoading(false);
                props.updateTable();
                onClosePopup();
            })
            .catch(() => {
                showToast('error', 'Failed to delete sort group');
                setLoading(false);
            });
    };

    useEffect(() => {
        console.log('props - ', props);
        console.log('props.payload - ', props.payload);
    }, []);

    return (
        <Modal show={props.show} onHide={props.toggle} centered className="no-margin">
            <Form>
                <Card>
                    <Card.Body>
                        <h4 className="mb-2">Delete {props.payload?.name}</h4>

                        <Row className="my-1 align-items-end">
                            <Col xs={12}>
                                You are about to remove the {props.payload?.name} configuration. Are you sure you want to proceed?
                            </Col>
                        </Row>

                        <div className="my-1 align-items-end row justify-content-end">
                            <div className="col-auto">
                                <button type="button" className="btn btn-cancel-custom" onClick={onClosePopup}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-delete-custom" onClick={onRemoveSortCodeConfig}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Form>
        </Modal>
    );
};

export default RemoveSortCodeConfig;